export default class Deferred<T> {
  public promise: Promise<T>;

  public reject!: (value: T | PromiseLike<T>) => void;
  public resolve!: (value: T | PromiseLike<T>) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.reject = reject;
      this.resolve = resolve;
    });
  }
}
